import { component } from 'picoapp'
import Cookies from 'js-cookie'
import '@/lib/jquery-global.js';

export default component((node, ctx) => {

    let discount_code = Cookies.get('discount_code')
    let discount_closed = Cookies.get('discount_closed')

    if (discount_code) {

        if (discount_closed) {

            if (discount_closed == discount_code) {

            } else {
                showNotification();
            }

        } else {
            showNotification();
        }
        
    }

    function showNotification() {
        var h = $(node).outerHeight();
        $('.__spacer').height(h);

        $( window ).resize(function() {
            var h = $(node).outerHeight();
            $('.__spacer').height(h);
        });

        jQuery(node).slideDown();

        setTimeout(function() {
            jQuery(node).slideUp();
            Cookies.set('discount_closed', discount_code);
            $('.__spacer').hide();
        }, 5000);
    }

})
